/* eslint-disable react/prop-types */
import React from 'react';
import { Input } from 'antd';

import InputWrapper from '../inputWrapper';

export default function MoneyInput({ value, setValue, title, note, placeholder, optional = false, error }) {
  const handleChange = (e) => {
    let val = e.target.value;

    // Replace comma with dot
    val = val.replace(/,/g, '.');

    // Remove everything except digits and dot
    val = val.replace(/[^\d.]/g, '');

    // Only allow one dot
    const parts = val.split('.');
    if (parts.length > 2) {
      val = parts[0] + '.' + parts.slice(1).join('');
    }

    // Limit to 2 decimal places
    if (parts[1]?.length > 2) {
      val = parts[0] + '.' + parts[1].slice(0, 2);
    }

    setValue(val);
  };

  return (
    <div className="money-input">
      <InputWrapper title={title} note={note} optional={optional} error={error}>
        <Input
          value={value ? `€ ${value}` : ''}
          onChange={handleChange}
          placeholder={placeholder}
          className="money"
        />
      </InputWrapper>
    </div>
  );
}